import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const cronTaskSchema = z.enum(['polling', 'maintenance']);
export type CronTask = z.infer<typeof cronTaskSchema>;

export const cronContract = c.router({
  runCronTask: {
    method: 'POST',
    path: '/internal/cron/:task',
    pathParams: z.object({ task: cronTaskSchema }),
    body: z.object({}).optional(),
    responses: {
      200: z.object({ task: cronTaskSchema, status: z.enum(['done', 'skipped']), reason: z.string().optional(), durationMs: z.number() }),
      401: z.object({ message: z.string() }),
    },
  },
});
